import { Outlet } from "react-router-dom";
import Header from "./Components/Header/Cabecalho/Cabecalho.jsx";
import Footer from "./Components/Footer/Footer.jsx";
import Scroll from "./Components/Scroll/Scroll.jsx";
import "./scss/global.scss";

function App() {
  return (
    <>
      <Header />
      <Scroll />
      <Outlet />
      <Footer />
    </>
  );
}

export default App;
